import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
const subs = new Set();

export const isLightHex = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return false;
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(m[1].slice(i, i + 2), 16) / 255).map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.4;
};

export const applyBrandVars = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return;
  const n = parseInt(m[1], 16);
  const rgb = [n >> 16, (n >> 8) & 255, n & 255];
  const s = document.documentElement.style;
  s.setProperty("--ec-green-rgb", rgb.join(" "));
  s.setProperty("--ec-green-dark-rgb", rgb.map((c) => Math.round(c * 0.8)).join(" "));
};


export const refreshBranding = () =>
  api.get("/agency/branding").then(({ data }) => { cache = data; subs.forEach((f) => f(data)); return data; });

export function useBranding() {
  const [b, setB] = useState(cache);
  useEffect(() => {
    subs.add(setB);
    refreshBranding().catch(() => {});
    return () => { subs.delete(setB); };
  }, []);
  return b;
}

export const POWERED = "powered by ImoDesk";
